<div class="expense-details-section">
  <h2 mat-dialog-title>Expense Overview</h2>

  <table class="expense-table">
    <tbody>
    <tr>
      <th>Report ID</th>
      <td>{{ expense.reportKey }}</td>
    </tr>
    <tr>
      <th>Expense Report Number</th>
      <td>{{ expense.id }}</td>
    </tr>
    <tr>
      <th>Report Name</th>
      <td>{{ expense.details[0].description }}</td>
    </tr>
    <tr>
      <th>Payment Type</th>
      <td>{{ expense.paymentType }}</td>
    </tr>
    <tr>
      <th>Total Expense Amount</th>
      <td>{{ expense.amount | currency: expense.currency }}</td>
    </tr>
    </tbody>
  </table>

  <h2 mat-dialog-title>Expense Details (Total split up)</h2>

  <!-- Expense Details Table -->
  <table class="expense-details-table">
    <thead>
    <tr>
      <th>Expense Type</th>
      <th>Paid By</th>
      <th>Currency</th>
      <th>Amount</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let detail of expense.details">
      <td>{{ detail.expenseFor }}</td>
      <td>{{ detail.expenseType }}</td>
      <td>{{ detail.currency }}</td>
      <td>{{ detail.amount | currency: detail.currency }}</td>
    </tr>
    </tbody>
  </table>

  <!-- Action Buttons -->
  <div mat-dialog-actions class="action-buttons">
    <button mat-button (click)="onCloseClick()">Close</button>
  </div>
</div>
